module.exports = __webpack_public_path__ + "img/img_ai_test_stock_card_bg@2x.d5414858.png";